import {CircularProgress} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

export const OrderIntakeLoadingState: React.FC = () => {
  const {t} = useTranslation()

  return (
    <div
      style={{
        padding: '2rem',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem'
      }}
    >
      <CircularProgress size={32} />
      <p>{t('orderIntake.rmc.loading.preparingOrderIntake')}</p>
    </div>
  )
}
